import React from "react";
import { Button } from "@mui/material";

const ExportToExcelButton: React.FC<{
  onClick: () => void;
  isLoading: boolean;
}> = ({ onClick, isLoading }) => {
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={() => onClick()}
      disabled={isLoading}
    >
      Export to Excel
    </Button>
  );
};

export default ExportToExcelButton;
